import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";
import style from "./Field.module.scss";
import { CounterPartySimpleReducer } from "../../CounterPartySet/reducer";

const Combobox = ({ value, items, emptyLabel, onChange, disabled, darken, ...restProps }) => (
  <Input
    type={"select"}
    value={value || -1}
    className={style.select}
    style={darken ? darkenStyle : {}}
    onChange={(e) => onChange(e.target.value)}
    disabled={disabled || !items}
    {...restProps}
  >
    {(value == undefined || value == -1) && (
      <option value={-1} disabled>
        {emptyLabel}
      </option>
    )}
    {/* {(items || []).find((ins) => ins.id == value) === undefined && (
      <option key={-1} value={value}>
        {value}
      </option>
    )} */}
    {(items || []).map((value, index) => (
      <option key={index} value={value.id}>
        {value.description}
      </option>
    ))}
  </Input>
);

const darkenStyle = {
  background: "#607d8b",
  color: "#fff",
  fontWeight: 500,
};

export default React.memo(Combobox);
